import axios from 'axios';
import { backend_url_dash } from '../constants/config';

const apiInstance = axios.create({
    baseURL: backend_url_dash,
    timeout: 40000, // timeout after 60 seconds
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
    withCredentials: true
});

export default apiInstance;